import {request} from "../../Base/HTTP";
import HttpMethod from "../../Constants/Base/HttpMethod";
import {
    getCompanyDocumentQuestionTypeString
} from "../../Constants/CompanyDocumentManagement/CompanyDocumentItem/CompanyDocumentQuestionType";


export async function getCompanyDocumentTemplateQuestions(data) {
    return await request('/api/company-document-template-questions', data);
}

export async function addCompanyDocumentTemplateQuestion(data) {
    return await request('/api/company-document-template-question', transformRequestData(data), HttpMethod.POST);
}

export async function deleteCompanyDocumentTemplateQuestion(id) {
    return await request('/api/company-document-template-question/' + id, {}, HttpMethod.DELETE);
}

export async function editCompanyDocumentTemplateQuestion(data) {
    return await request('/api/company-document-template-question/' + data.id, transformRequestData(data), HttpMethod.PUT);
}

function transformRequestData(data) {
    let dataType;
    if(data.type?.value){
        dataType = data.type;
    }else{
        dataType = {name: getCompanyDocumentQuestionTypeString(data.type), value: data.type}
    }
    return {
        ...data,
        description: data.explanation ? data.explanation : null,
        type: dataType.value
    }
}
